import React from 'react';
import { useProgressCalculation, getProgressGradient } from '../hooks/useProgressCalculation';
import { useTheme } from '../contexts/ThemeContext';
import { TodoTree } from '../types/todo';

interface ProgressBarProps {
  tree: TodoTree;
  nodeId: string;
  className?: string;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ tree, nodeId, className = '' }) => {
  const progress = useProgressCalculation(tree, nodeId);
  const { theme } = useTheme();

  // Don't render progress bar for leaf nodes
  if (!progress.hasChildren) {
    return null;
  }

  const gradient = getProgressGradient(progress.percentage, theme === 'dark');

  return (
    <div className={`progress-bar-container ${className}`}>
      <div
        className="progress-bar"
        role="progressbar"
        aria-valuenow={progress.percentage}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label={`Progress: ${progress.percentage}% complete`}
      >
        <div
          className="progress-fill"
          style={{
            width: `${progress.percentage}%`,
            background: gradient,
          }}
        />
      </div>
    </div>
  );
};

export default ProgressBar;